import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

/**
 * Role-aware landing redirect.
 * Must be used INSIDE ProtectedRoute (auth already checked).
 * - Super Admins → /platform
 * - Org Owners with NO businesses → /firm/onboarding
 * - Org Owners without active business → /organization?tab=profile
 * - Business users → /dashboard
 */
export function HomeRedirect() {
  const { isSuperAdmin, isOrgAdmin, activeBusinessId, businessMemberships, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  // Super Admin → Platform dashboard
  if (isSuperAdmin) {
    return <Navigate to="/platform" replace />;
  }

  // Org Owner with NO businesses at all → Onboarding wizard
  if (isOrgAdmin && businessMemberships.length === 0) {
    return <Navigate to="/firm/onboarding" replace />;
  }

  // Org Owner with businesses but no active → Organization page (to select business)
  if (isOrgAdmin && !activeBusinessId) {
    return <Navigate to="/organization?tab=profile" replace />;
  }

  // Default → Business dashboard
  return <Navigate to="/dashboard" replace />;
}
